module.exports = __webpack_public_path__ + "img/VC.42912e3a.svg";